/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Ai_Api_Reference_DetailInputs */

const en_common_header_ai_api_reference_detail = /** @type {(inputs: Common_Header_Ai_Api_Reference_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public API status`)
};

const zh_common_header_ai_api_reference_detail = /** @type {(inputs: Common_Header_Ai_Api_Reference_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公共 API 状态`)
};

/**
* | output |
* | --- |
* | "Public API status" |
*
* @param {Common_Header_Ai_Api_Reference_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_ai_api_reference_detail = /** @type {((inputs?: Common_Header_Ai_Api_Reference_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Ai_Api_Reference_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_ai_api_reference_detail(inputs)
	return zh_common_header_ai_api_reference_detail(inputs)
});
export { common_header_ai_api_reference_detail as "common.header.ai.api_reference.detail" }